// Fonction utilitaire pour découper un tableau en sous-tableaux de taille spécifiée
export function chunk(array, size) {
  return Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
    array.slice(i * size, (i + 1) * size),
  );
}
